@if (logo$ | async; as logo) {
  <tm-image-with-description
    [src]="logo"
    class="logo custom-logo">
  </tm-image-with-description>
} @else {
  <mat-icon class="logo" svgIcon="logo"></mat-icon>
}

